/**
 * This file was generated
 * Do not edit directly
 * See 'fusion-design-system/build-style-dictionary.js' for more info
 */

export const textColorUtilityVariants = () => ({
    "placeholder": "sui-u-color-placeholder",
    "link": "sui-u-color-link",
    "hover": "sui-u-color-hover",
    "selected": "sui-u-color-selected",
    "disabled": "sui-u-color-disabled",
    "low-contrast": "sui-u-color-low-contrast",
    "mid-contrast": "sui-u-color-mid-contrast",
    "high-contrast": "sui-u-color-high-contrast",
    "inverse": "sui-u-color-inverse",
    "primary": "sui-u-color-primary",
    "primary-hover": "sui-u-color-primary-hover",
    "critical": "sui-u-color-critical",
    "warning": "sui-u-color-warning",
    "positive": "sui-u-color-positive",
    "info": "sui-u-color-info",
});
